import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@sequelae/lore-core';
import { useNavigationMode } from '../../contexts/NavigationModeContext';
import { NavigationModeToggle } from '../../components/NavigationModeToggle';
import { NavigationTestButtons } from '../../components/NavigationTestButtons';
import '../../styles/shared-styles.css';
import '../../styles/about.css';

export const Terms = () => {
  const navigate = useNavigate();
  const { isNativeMode } = useNavigationMode();

  return (
    <div className="screen">
      <div className="shared-container">
        <div
          className="menu-container android terms-container"
          style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
        >
          <header className="menu-header">
            {!isNativeMode && (
              <Button className="back-button" onClick={() => navigate(-1)} variant="text">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
                    fill="#1C1B1F"
                  />
                </svg>
              </Button>
            )}
            <Typography variant="h1" className="menu-header-title">
              Terms of Use
            </Typography>
            <NavigationModeToggle />
          </header>

          <div>
            <iframe
              src="https://www.lore.co/terms"
              title="Terms of Use"
              className="iframe-fullscreen"
            />
            <div className="navigation-test-spacer">
              <NavigationTestButtons />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
